import { useQuery } from '@tanstack/react-query';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';

import ErrorBoundary from 'components/ErrorBoundary';

import { landingQueryKeys } from 'lib/queryKeys';

import { getLandingsList } from 'services/landing';

const FeaturedLandingLink = dynamic(() => import('./FeaturedLandingLink'), {
  ssr: true,
});

const FeaturedLandings = ({ gaEventCategory }) => {
  const { data: featuredLandings = [], isLoading } = useQuery({
    queryKey: landingQueryKeys.featured(),
    queryFn: ({ signal }) => getLandingsList({ featured: true }, { signal }),
    select: (data) => data.landings,
    enabled: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });

  if (isLoading || featuredLandings?.length === 0) {
    return null;
  }

  return (
    <ErrorBoundary>
      {featuredLandings.map(
        ({ landingId, landingSlug, landingName, landingType }, index) => (
          <FeaturedLandingLink
            key={landingId}
            gaEventCategory={gaEventCategory}
            landingId={landingId}
            landingName={landingName}
            landingSlug={landingSlug}
            landingType={landingType}
            position={index + 1}
          />
        )
      )}
    </ErrorBoundary>
  );
};

FeaturedLandings.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default FeaturedLandings;
